/**
 * Component c-blank
 * @type {String}
 */

class ToggleSubtab {
    constructor(trigger, target) {
        this.triggerList = document.querySelectorAll(trigger);
        this.targetList = document.querySelectorAll(target);
    }

    bindEvent() {
        this.triggerList.forEach(
            trigger => {
                trigger.addEventListener(
                    'click', () => {
                        this.clearAll();
                        trigger.classList.add('-state--active');
                        this.targetList.forEach(
                            target => {
                                if (target.dataset.id === trigger.dataset.id) {
                                    target.classList.add('-state--active');
                                }
                            }
                        );
                    }
                );
            }
        );
    }

    clearAll() {
        this.triggerList.forEach(
            sel => {
                sel.classList.remove('-state--active');
            }
        );
        this.targetList.forEach(
            sel => {
                sel.classList.remove('-state--active');
            }
        );
    }
}

let subtabs = new ToggleSubtab(".js-subtabs__trigger", ".js-subtabs__target");
subtabs.bindEvent();